/**
 * Product Image Magnifier - Auto-Enabled Version
 * Always-on magnifier without toggle button
 */
(function() {
  'use strict';
  
  function waitForJQuery() {
    if (typeof jQuery === 'undefined') {
      setTimeout(waitForJQuery, 50);
      return;
    }
    init(jQuery);
  }
  
  waitForJQuery();
  
  function init($) {
    var preloadedImages = {};
    var magnifierRefreshTimer = null;
    var lastPointerPosition = null;
    var desktopZoomIcon = document.querySelector('.desktop-zoom-icon');

    function setDesktopZoomIconVisible(visible) {
      if (desktopZoomIcon) {
        desktopZoomIcon.classList.toggle('is-visible', Boolean(visible));
      }
    }

    document.addEventListener('mousemove', function(event) {
      lastPointerPosition = {
        pageX: event.pageX,
        pageY: event.pageY
      };
    }, { passive: true });

    function hasMousePointer() {
      if (window.matchMedia) {
        return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      }

      return !('ontouchstart' in window);
    }

    function getZoomQuality(img, masterImage) {
      if (!window.PDPZoomQuality) {
        return { enabled: false, capacity: 0, zoom: 0 };
      }

      return window.PDPZoomQuality.getImageQuality(
        img,
        masterImage && masterImage.naturalWidth,
        masterImage && masterImage.naturalHeight
      );
    }

    // Preload only the active high-res image. Preloading every master image
    // competes with the responsive gallery images and defeats lazy loading.
    function preloadActiveMasterImage() {
      if (!hasMousePointer()) return;

      var $container = $('#sync1 .owl-item.active .img-magnifier-container').first();
      if (!$container.length) {
        $container = $('#sync1 .img-magnifier-container').first();
      }

      var activeImage = $container.find('.product-main-image').first()[0];
      if (!getZoomQuality(activeImage).enabled) return;

      var masterUrl = $container.data('zoom-image');
      if (masterUrl && !preloadedImages[masterUrl]) {
        var img = new Image();
        img.src = masterUrl;
        preloadedImages[masterUrl] = img;
      }
    }

    // Create magnifier
    function magnify(img) {
      if (
        !img ||
        !img.src ||
        img.naturalWidth <= 1 ||
        img.src.includes('gtm') ||
        img.src.includes('tracking')
      ) return;

      var initialQuality = getZoomQuality(img);
      if (!initialQuality.enabled) return;

      if (img.pdpMagnifierCleanup) {
        img.pdpMagnifierCleanup();
      }
      
      var magnifierGlass = document.createElement("DIV");
      magnifierGlass.className = "img-magnifier-glass";
      var magnifierPreview = document.createElement("DIV");
      magnifierPreview.className = "img-magnifier-preview";
      magnifierGlass.appendChild(magnifierPreview);
      img.parentElement.insertBefore(magnifierGlass, img);
      img.pdpMagnifierGlass = magnifierGlass;
      
      var masterUrl = img.dataset.master || img.src;
      var masterImage = preloadedImages[masterUrl];
      var isDestroyed = false;
      var zoom = initialQuality.zoom;

      if (!masterImage) {
        masterImage = new Image();
        preloadedImages[masterUrl] = masterImage;
        masterImage.src = masterUrl;
      }
      
      var bw = 3, w = magnifierGlass.offsetWidth / 2, h = magnifierGlass.offsetHeight / 2;

      function setBackgroundSize(element) {
        var renderedRect = img.getBoundingClientRect();
        element.style.backgroundSize =
          (renderedRect.width * zoom) + "px " +
          (renderedRect.height * zoom) + "px";
      }

      magnifierPreview.style.backgroundImage = "url('" + (img.currentSrc || img.src) + "')";
      setBackgroundSize(magnifierPreview);
      magnifierGlass.classList.add('is-loading');
      
      function move(e) {
        e.preventDefault();
        var rect = img.getBoundingClientRect();
        var x = e.pageX - rect.left - window.pageXOffset;
        var y = e.pageY - rect.top - window.pageYOffset;
        
        if (x > rect.width - (w / zoom)) x = rect.width - (w / zoom);
        if (x < w / zoom) x = w / zoom;
        if (y > rect.height - (h / zoom)) y = rect.height - (h / zoom);
        if (y < h / zoom) y = h / zoom;
        
        magnifierGlass.style.left = (x - w) + "px";
        magnifierGlass.style.top = (y - h) + "px";
        var backgroundPosition = "-" + ((x * zoom) - w + bw) + "px -" + ((y * zoom) - h + bw) + "px";
        magnifierGlass.style.backgroundPosition = backgroundPosition;
        magnifierPreview.style.backgroundPosition = backgroundPosition;
      }
      
      function hideGlass() {
        magnifierGlass.style.opacity = "0";
        img.classList.remove('pdp-magnifier-pointer-hidden');

        var $currentItem = $(img).closest('.owl-item');
        var isActiveImage = !$currentItem.length || $currentItem.hasClass('active');
        var zoomAvailable = !magnifierGlass.classList.contains('is-preview-only') &&
          getZoomQuality(img, masterImage).enabled;
        setDesktopZoomIconVisible(isActiveImage && zoomAvailable);
      }

      function showGlass() {
        magnifierGlass.style.opacity = "1";
        img.classList.add('pdp-magnifier-pointer-hidden');
        setDesktopZoomIconVisible(false);
      }

      function revealAtLastPointerPosition() {
        if (!img.matches || !img.matches(':hover')) return;

        showGlass();

        if (lastPointerPosition) {
          move({
            pageX: lastPointerPosition.pageX,
            pageY: lastPointerPosition.pageY,
            preventDefault: function() {}
          });
        }
      }

      function markMagnifierReady() {
        if (isDestroyed || !masterImage.naturalWidth) return;

        var $currentItem = $(img).closest('.owl-item');
        if ($currentItem.length && !$currentItem.hasClass('active')) return;

        var currentQuality = getZoomQuality(img, masterImage);
        if (!currentQuality.enabled) {
          setDesktopZoomIconVisible(false);
          img.pdpMagnifierCleanup();
          magnifierGlass.remove();
          return;
        }

        zoom = currentQuality.zoom;
        setDesktopZoomIconVisible(true);
        magnifierGlass.style.backgroundImage = "url('" + masterUrl + "')";
        setBackgroundSize(magnifierGlass);
        magnifierGlass.classList.remove('is-loading');
        magnifierGlass.classList.add('is-ready');
        revealAtLastPointerPosition();
      }

      function markMagnifierFailed() {
        if (isDestroyed) return;

        setDesktopZoomIconVisible(false);
        magnifierGlass.classList.remove('is-loading');
        magnifierGlass.classList.add('is-preview-only');
      }

      magnifierGlass.addEventListener("mousemove", move);
      img.addEventListener("mousemove", move);
      img.addEventListener("mouseleave", hideGlass);
      img.addEventListener("mouseenter", showGlass);

      img.pdpMagnifierRefresh = function() {
        if (isDestroyed) return false;

        var currentQuality = getZoomQuality(
          img,
          masterImage.complete && masterImage.naturalWidth ? masterImage : null
        );
        if (!currentQuality.enabled) {
          img.pdpMagnifierCleanup();
          return false;
        }

        zoom = currentQuality.zoom;
        w = magnifierGlass.offsetWidth / 2;
        h = magnifierGlass.offsetHeight / 2;
        magnifierPreview.style.backgroundImage = "url('" + (img.currentSrc || img.src) + "')";
        setBackgroundSize(magnifierPreview);

        if (magnifierGlass.classList.contains('is-ready')) {
          setBackgroundSize(magnifierGlass);
        }

        revealAtLastPointerPosition();
        return true;
      };

      img.pdpMagnifierCleanup = function() {
        isDestroyed = true;
        img.classList.remove('pdp-magnifier-pointer-hidden');
        masterImage.removeEventListener('load', markMagnifierReady);
        masterImage.removeEventListener('error', markMagnifierFailed);
        magnifierGlass.removeEventListener("mousemove", move);
        img.removeEventListener("mousemove", move);
        img.removeEventListener("mouseleave", hideGlass);
        img.removeEventListener("mouseenter", showGlass);
        magnifierGlass.remove();
        delete img.pdpMagnifierGlass;
        delete img.pdpMagnifierRefresh;
        delete img.pdpMagnifierCleanup;
      };

      if (masterImage.complete && masterImage.naturalWidth) {
        markMagnifierReady();
      } else if (masterImage.complete) {
        markMagnifierFailed();
      } else {
        masterImage.addEventListener('load', markMagnifierReady, { once: true });
        masterImage.addEventListener('error', markMagnifierFailed, { once: true });
      }
    }

    function initializeLoadedImage(img) {
      if (!img) return;

      var $item = $(img).closest('.owl-item');
      if ($item.length && !$item.hasClass('active')) return;

      if (img.pdpMagnifierGlass && img.pdpMagnifierGlass.isConnected) {
        img.pdpMagnifierRefresh();
        return;
      }

      if (img.pdpMagnifierInitializing) return;
      img.pdpMagnifierInitializing = true;

      function initializeAfterDecode() {
        delete img.pdpMagnifierInitializing;

        var $currentItem = $(img).closest('.owl-item');
        if ($currentItem.length && !$currentItem.hasClass('active')) return;

        if (img.pdpMagnifierGlass && img.pdpMagnifierGlass.isConnected) {
          img.pdpMagnifierRefresh();
        } else {
          magnify(img);
        }
      }

      if (typeof img.decode === 'function') {
        img.decode().catch(function() {}).then(initializeAfterDecode);
      } else {
        initializeAfterDecode();
      }
    }

    // Initialize - Auto-enabled
    function startMagnifier() {
      if (!hasMousePointer()) {
        setDesktopZoomIconVisible(false);
        return;
      }

      var $activeItem = $('#sync1 .owl-item.active').first();
      var $img = $activeItem.find('.product-main-image').first();
      if (!$img.length && !$activeItem.length) {
        $img = $('#sync1 .product-main-image').first();
      }
      if (!$img.length) {
        setDesktopZoomIconVisible(false);
        return;
      }

      var activeImage = $img[0];
      setDesktopZoomIconVisible(getZoomQuality(activeImage).enabled);

      $('#sync1 .product-main-image').each(function() {
        if (this !== activeImage && this.pdpMagnifierCleanup) {
          this.pdpMagnifierCleanup();
        }
      });

      $('.img-magnifier-glass').each(function() {
        if (this !== activeImage.pdpMagnifierGlass) {
          this.remove();
        }
      });

      if (activeImage.pdpMagnifierGlass && activeImage.pdpMagnifierGlass.isConnected) {
        activeImage.pdpMagnifierRefresh();
      } else if (activeImage.complete && activeImage.naturalWidth > 1) {
        initializeLoadedImage(activeImage);
      } else {
        $img.off('load.pdpMagnifier').one('load.pdpMagnifier', function() {
          initializeLoadedImage(this);
        });
      }
    }

    function scheduleMagnifierRefresh(delay) {
      clearTimeout(magnifierRefreshTimer);
      magnifierRefreshTimer = setTimeout(function() {
        preloadActiveMasterImage();
        startMagnifier();
      }, delay || 0);
    }

    // Auto-start on load and carousel change
    $(document).ready(function() {
      setTimeout(function() {
        preloadActiveMasterImage();
        startMagnifier(); // Auto-start immediately
        
        $('#sync1').on('changed.owl.carousel', function() {
          scheduleMagnifierRefresh(50);
        });

        $('#sync1').on('translated.owl.carousel refreshed.owl.carousel', function() {
          scheduleMagnifierRefresh();
        });

        $('#sync1').on('loaded.owl.lazy', function(event) {
          var activeImage = $('#sync1 .owl-item.active .product-main-image').first()[0];
          var loadedImage = event.element && event.element.jquery
            ? event.element[0]
            : event.element;

          if (loadedImage === activeImage) {
            scheduleMagnifierRefresh();
          }
        });

        $(window).on('resize.pdpMagnifier orientationchange.pdpMagnifier', function() {
          scheduleMagnifierRefresh(100);
        });
      }, 100);
    });
  }
})();
